<template>
    <el-dialog title="上传PSD文件" :visible.sync="$parent.uploadPsdStatus" class="move-dialog upload-psd" width="414px">
        <el-upload class="avatar-uploader" :http-request="uploadPSD" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" v-if="uploadBefore">
            <img src="../../../../assets/image/psdUpload.png" />
            <span>选择PSD文件</span>
        </el-upload>
        <div class="uploading-process" v-else>
            <div class="uploading-process-inner">
                <p class="upload-progress-text">{{ uploadToastText }}</p>
                <el-progress :percentage="uploadPercentage" :show-text="false" color="#7966FF"></el-progress>
            </div>
        </div>
        <div class="upload-text">
            <div class="title">导入建议：</div>
            <p>选择一个PSD源文件，大小不超过50M</p>
            <p>PSD尺寸限制为<span>40*40~6000*6000</span></p>
            <p>为确保正常显示，请先将图层样式与蒙版图层栅格化</p>
            <p>PSD上传后，文字部分需要使用文字工具重新编辑</p>
        </div>
    </el-dialog>
</template>

<script>
import { Space, User } from "@/config/axios/new_api";
export default {
    props: {
        teamid: {
            type: Number,
        },
        dirid: {
            type: Number,
        },
        source: {
            type: String,
            default: "template",
        },
    },
    data() {
        return {
            uploadFolderVisible: false,
            // 默认显示上传控件
            uploadBefore: true,
            // 上传psd的提示文字
            uploadToastText: "文件上传中",
            // 上传进度的百分比
            uploadPercentage: 0,
        };
    },
    computed: {
        loginInfo() {
            return this.$store.getters.loginInfo;
        },
    },
    methods: {
        // 上传psd文件
        async uploadPSD(params) {
            let file = params.file;
            var dotIndex = file.name.lastIndexOf(".") + 1;
            var fileTypeStr = file.name.slice(dotIndex);
            var { teamid, dirid } = this;
            if (fileTypeStr !== "psd") {
                this.$message({
                    message: "请上传psd格式文件",
                    center: true,
                    customClass: "handle-success",
                });
                return;
            }
            // 判断文件大小是否大于50M
            let size = parseInt(file.size / 1024 / 1024);
            if (size >= 50) {

                return;
            }

            // 显示文件上传中
            this.uploadBefore = false;
            // 通过formData把上传的附件给收集起来
            let that = this;
            let psdObj = {};

            this.browserParsePsd2(file)
                .then((response) => {
                    //  开始文件解析的显示
                    that.uploadToastText = "文件解析中";
                    that.uploadPercentage = 90;

                    // 上传成功，将数据存在session中
                    psdObj.document_info = response.document_info;
                    psdObj.layers_info = response.layers_info.reverse();
                    psdObj.canvas_name = response.canvas_name;
                    response.team_id = teamid;
                    response.dir_id = dirid;
                    sessionStorage.setItem("psdObj", JSON.stringify(response));

                    this.$nextTick(() => {
                        this.$parent.psdClose();
                        Space.savePSD({ psd: JSON.stringify(response) }).then((res) => {
                            if (res.status === 1) {
                                let baseHref = process.env.VUE_APP_BaseHref;
                                if (baseHref[baseHref.length - 1] === "/") {
                                    baseHref = baseHref.slice(0, baseHref.length - 1);
                                }
                                let base64 = new setBase64Encry();
                                let result = base64.encode(this.loginInfo.current_team_id + "");
                                let href = `/enterprise-design-v1?mode=4&ckey=custom&cw=${response.document_info.width}&ch=${response.document_info.height}&nature=team&psd=${res.data}&source=${that.source}&md5=${result}`;
                                // let href = `${baseHref}/enterprise-design-v1?mode=4&ckey=custom&cw=${response.document_info.width}&ch=${response.document_info.height}&nature=team&psd=${res.data}&source=${that.source}`;
                                that.uploadBefore = true;
                                that.uploadToastText = "文件上传中";
                                that.uploadPercentage = 0;
                                window.location.href = href;
                                // window.open(href);
                            }
                        });
                    });
                })
                .catch(() => {
                    that.$message({
                        message: "上传失败",
                        center: true,
                        customClass: "handle-success",
                    });
                });
        },
        //解析调整
        browserParsePsd2(file) {
            return new Promise((resolve, reject) => {
                let document_info = {}; // 存储document信息，包含宽高，分辨率（）等
                let url = URL.createObjectURL(file); // 创建一个domstring,获取新的url对象，指示file对象
                window.PSD.fromURL(url).then((psd) => {
                    let psd_img_element = psd.image.toPng() // 获取psd文件对应生成的<img></img>
                    let tree = psd.tree() // 获取psd文件的树形结构
                    let treeInfo = tree.export() // 获取psd文件的树形结构信息
                    document_info = treeInfo.document

                    if (
                        document_info.width < 40 ||
                        document_info.width > 6000 ||
                        document_info.height < 40 ||
                        document_info.height > 6000
                    ) {
                        this.$confirm(
                            "上传失败，请上传画布尺寸的取值范围为 40px*40px 至 6000px*6000px",
                            "温馨提示",
                            {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: "warning",
                            }
                        );

                    }

                    let layer_info_ary = tree.descendants().map(async (layer) => {

                        if (layer.isGroup()) return false; // 过滤掉psd组
                        if (layer.width === 0 || layer.height === 0) return false; // 过滤掉宽度或高度为0的图层
                        if (!layer.export().visible) return false; // 过滤掉visible为false的图层



                        let blob;
                        let { width, height, top, bottom, left, right } = layer;
                        let layer_info = {
                            // 图层基本信息
                            opacity: layer.get("opacity"),
                            width,
                            height,
                            top,
                            bottom,
                            left,
                            right,
                        };
                        if (!layer.get("typeTool")) {
                            layer_info.type = 'image'
                            layer_info.halfleading = false
                            try {
                                layer.layer.image.toBase64()
                            } catch (error) {
                                return false;
                            }

                            // blob = dataURLtoBlob(layer.layer.image.toBase64()) // base64转blob；
                            blob = layer.layer.image.toBase64() // base64转blob；

                        } else { // 文字图层
                            layer_info.type = 'text'
                            layer_info.text = layer.export().text

                            layer_info.text.tracking = layer.get('typeTool').styles().Tracking // 获取字间距

                            layer_info.text.orientation = layer.get('typeTool').textData.Ornt // 获取文字方向

                            let autoLeading = layer.get('typeTool')._styles.AutoLeading // 是否自动设置行高
                            if (autoLeading && autoLeading.length > 0 && autoLeading[0]) { // 便是自动获取行高
                                layer_info.text.font.leading = layer_info.text.font.leading.map(item => 'auto')
                            }
                            layer_info.text.fontCaps = layer.get('typeTool')._styles.FontCaps // 判断是否大写
                            //如果有旋转,且图层拥有boundingbox属性的情况下,图层的宽高使用boundbox相关的数据进行计算
                            //旋转图层的half-leading的矫正加上去 (行高 - 字号)/2
                            let transform = layer_info.text.transform
                            let rotate = handleRotation(transform)

                            if (rotate !== 0) {
                                if (layer.get('typeTool')) {
                                    let textData = layer.get('typeTool').textData
                                    let text_info = layer.export().text
                                    let bounds = textData.bounds

                                    if (bounds) {

                                        layer_info.width = parseInt(bounds.Rght.value - bounds.Left.value)
                                        layer_info.height = parseInt(bounds.Btom.value - bounds['Top '].value)
                                        if (transform.xy !== 0 && transform.yx !== 0) {
                                            let yy = Math.abs(a(transform.xy) * Math.sqrt(Math.pow(a(transform.yx), 2) + Math.pow(a(transform.xx), 2)) / a(transform.yx)).toFixed(2) * 1
                                            let yyisNumber = isNaN(yy) ? false : true

                                            if (yyisNumber) {
                                                layer_info.width *= yy
                                                layer_info.height *= yy
                                            }

                                        }


                                        layer_info.halfleading = true


                                    } else {
                                        layer_info.halfleading = false
                                    }

                                }
                            } else {
                                layer_info.halfleading = false
                            }

                        }
                        if (blob) {
                            layer_info.image_url = await uploadBlob(blob);
                        };

                        return layer_info;

                    });

                    Promise.all(layer_info_ary).then((layers_info) => {

                        // 用promise.all获取最终的数据
                        layers_info = layers_info.filter((item) => item);
                        console.log(layers_info)
                        //销毁url
                        URL.revokeObjectURL(url);
                        resolve({
                            layers_info, // 存储图层信息
                            psd_img_element,
                            document_info,
                            file_name: file.name,
                            canvas_name: file.name.substring(0, file.name.lastIndexOf(".")),
                        });
                    });
                })
                    .catch((e) => {
                        console.log(e);
                    });
            });

            //   base64转blob的方法
            function dataURLtoBlob(dataurl) {
                let arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                });
            }

            // 上传blob
            function uploadBlob(blob) {
                return new Promise((resolve) => {
                    User.upLoadBase64({upload_type: 'images', image_url: blob}).then(res => {
                        if(res.status == 1) {
                            resolve(res.data.url)
                        }
                    })
                });
            }

            // 处理旋转角度
            function handleRotation(transform) {
                let rotation = Math.round(
                    Math.atan(transform.xy / transform.xx) * (180 / Math.PI)
                );

                if (transform.xx < 0) {
                    rotation += 180;
                }
                if (rotation < 0) {
                    rotation += 360;
                }

                return rotation;
            }

            function a(number) {
                return number.toFixed(2) * 1;
            }
        }
    }
};
function setBase64Encry() {
    // private property
    let _keyStr =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    // public method for encoding
    this.encode = function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = _utf8_encode(input);
        while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output =
            output +
            _keyStr.charAt(enc1) +
            _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) +
            _keyStr.charAt(enc4);
        }
        return output;
    };

    // public method for decoding
    this.decode = function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        // eslint-disable-next-line no-useless-escape
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
        }
        }
        output = _utf8_decode(output);
        return output;
    };

    // private method for UTF-8 encoding
    function _utf8_encode(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
            utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
        } else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
        }
        }
        return utftext;
    }

    // private method for UTF-8 decoding
    function _utf8_decode(utftext) {
        var string = "";
        // eslint-disable-next-line no-unused-vars
        var c1, c2, c3;
        var i = 0;
        var c = (c1 = c2 = 0);
        while (i < utftext.length) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
            string += String.fromCharCode(c);
            i++;
        } else if (c > 191 && c < 224) {
            c2 = utftext.charCodeAt(i + 1);
            string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
            i += 2;
        } else {
            c2 = utftext.charCodeAt(i + 1);
            c3 = utftext.charCodeAt(i + 2);
            string += String.fromCharCode(
            ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
            );
            i += 3;
        }
        }
        return string;
    }
}
</script>

<style lang="scss" scoped>
.upload-psd {
    ::v-deep( .el-dialog) {
        height: 500px;
    }
    ::v-deep( .el-dialog__header) {
        padding-left: 30px;
        box-sizing: border-box;
        text-align: left;
        padding-top: 28px;
        height: 70px;

        .el-dialog__title {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #3b3946;
        }

        .el-dialog__headerbtn {
            top: 24px;
        }
    }
    ::v-deep( .avatar-uploader) {
        width: 358px;
        height: 222px;
        margin: 0 auto;
        border-radius: 4px;
        border: 2px dashed #e2e2e2;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .el-upload--text {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            img {
                width: 65px;
            }

            span {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #5a2df5;
                margin-top: 12px;
            }
        }
    }
    ::v-deep( .el-upload__tip) {
        font-size: 14px;
        font-weight: 400;
        color: #646469;
        line-height: 20px;
        text-align: center;
        margin-top: 48px;
    }
    ::v-deep( .el-button) {
        @include wh(124px, 124px);
        @include lineH(124px);
        text-align: center;
        background: #aaaab1;
        border-radius: 20px;
        margin: 0 auto;
        color: #ffffff;
        padding: 0;
        border: none;
        .iconfont {
            font-size: 38px;
        }
    }
}
.uploading-process {
    width: 358px;
    height: 222px;
    margin: 0 auto;
    border-radius: 4px;
    border: 2px dashed #e2e2e2;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;

    .uploading-process-inner {
        width: 124px;
    }
    .upload-progress-text {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: rgba(112, 112, 112, 1);
        margin-bottom: 14px;
        text-align: center;
    }
}
.upload-text {
    padding-left: 30px;
    margin-top: 30px;

    .title {
        font-size: 16px;
        color: #3b3946;
        margin-bottom: 14px;
    }

    p {
        color: #838089;
        margin-bottom: 6px;
        padding-left: 16px;
        position: relative;

        &:before {
            content: "";
            width: 2px;
            height: 2px;
            background: #838089;
            border-radius: 100%;
            position: absolute;
            left: 3px;
            top: 10px;
        }

        span {
            color: #5a2df5;
        }
    }
}
</style>
